module.exports = __webpack_public_path__ + "img/event_icon.b2531f97.svg";